import React from 'react';
import {withStyles} from '@wix/native-components-infra/dist/es/src/HOC/withStyles/withStyles';
import {withLeanStyles} from '@wix/native-components-infra/dist/es/src/HOC/withStyles/withLeanStyles';
import {withGlobalPropsProvider} from '../providers/globalPropsProvider';
import {getRuntimeStyleParams} from './styleParamsService';
import {getStyleParamsWithDefaults} from '@wix/wixstores-client-common-components/dist/es/src/outOfIframes/defaultStyleParams/getStyleParamsWithDefaults';
import {FormFactor} from '../constants';
import {withStrictMode} from '@wix/wixstores-client-common-components/dist/es/src/HOC/strictMode';

/* istanbul ignore next: HOC wrapper for handling null style from async loading */
const withSafeDefaultStyleParams = (
  WrappedComponent: React.ComponentType<any>,
  getDefaultStyleParamsFunc: (props: any) => {defaults: any; overrides?: any}
) => {
  return function SafeDefaultStyleParams(props: any) {
    const style = props.host?.style;

    if (!style || !style.siteColors || !style.styleParams) {
      return null;
    }

    const safeStyleParams = {
      ...style.styleParams,
      colors: style.styleParams.colors ?? {},
    };

    const styleWithDefaultStyleParams = {
      ...style,
      styleParams: getStyleParamsWithDefaults(safeStyleParams, () => getDefaultStyleParamsFunc(props)),
    };

    const host = {
      ...props.host,
      style: styleWithDefaultStyleParams,
    };

    return <WrappedComponent {...props} style={styleWithDefaultStyleParams} host={host} />;
  };
};

export const bootstrapApp = (
  Component: React.ComponentType,
  withStylesHoc: typeof withStyles | typeof withLeanStyles
) =>
  withSafeDefaultStyleParams(
    withStylesHoc(withStrictMode(withGlobalPropsProvider(Component)), {strictMode: true}),
    /* istanbul ignore next: callback used by withSafeDefaultStyleParams */
    (props: any) => {
      const {
        host: {style, formFactor},
        widgetPreset,
      } = props;

      const styleParams = style?.styleParams ?? {};
      const mobileOverrides = {};
      return {
        defaults: getRuntimeStyleParams(styleParams, {
          formFactor,
          widgetPreset,
        }),
        ...(formFactor === FormFactor.Mobile ? {overrides: mobileOverrides} : {}),
      };
    }
  );
